@if (item().comingSoon) {
  <!-- ARC-063: item "em breve" — módulo liberado, tela ainda não construída.
       Não navega, esmaecido, badge, aria-disabled e fora do fluxo de foco de ação. -->
  <div
    class="menu-item menu-item--coming-soon"
    aria-disabled="true"
    [attr.aria-label]="item().label + ' — em breve'"
    [title]="collapsed() ? item().label + ' — em breve' : 'Disponível em breve'">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
    @if (!collapsed()) {
      <span class="menu-item-badge" aria-hidden="true">em breve</span>
    }
  </div>
} @else if (hasChildren() && !collapsed()) {
  <!-- ADR-012: agrupador com submenu — alterna expandir/recolher, não navega. -->
  <button
    type="button"
    class="menu-item menu-item--group"
    [class.active]="hasActiveChild()"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="'submenu-' + item().id"
    (click)="toggleExpanded()">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
    <svg
      class="menu-item-chevron"
      [class.menu-item-chevron--expanded]="expanded()"
      width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M4 5.5L7 8.5L10 5.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  @if (expanded()) {
    <ul class="menu-submenu" [id]="'submenu-' + item().id" role="list">
      @for (child of item().children; track child.id) {
        <li role="listitem">
          <app-sidebar-menu-item [item]="child" [collapsed]="false" (itemClick)="onClick()" />
        </li>
      }
    </ul>
  }
} @else if (hasChildren() && collapsed()) {
  <!-- Sidebar recolhida: sem espaço para lista — navega direto ao 1º filho. -->
  <a
    class="menu-item"
    [class.active]="hasActiveChild()"
    [routerLink]="firstChildRoute()"
    (click)="onClick()"
    [attr.aria-label]="item().label"
    [title]="item().label">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
  </a>
} @else {
  <a
    class="menu-item"
    [class.active]="active()"
    [routerLink]="route()"
    (click)="onClick()"
    [attr.aria-current]="active() ? 'page' : null"
    [attr.aria-label]="collapsed() ? item().label : null"
    [title]="collapsed() ? item().label : ''">
    <ng-container [ngTemplateOutlet]="body"></ng-container>
  </a>
}

<ng-template #body>
  <span class="menu-item-icon" aria-hidden="true">
    <ng-container [ngSwitch]="item().icon">

      <ng-container *ngSwitchCase="'home'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2.5 8.5L9 3L15.5 8.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 7.5V15H14V7.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 15V11H11V15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'folder'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 5C2 4.448 2.448 4 3 4H7L9 6H15C15.552 6 16 6.448 16 7V14C16 14.552 15.552 15 15 15H3C2.448 15 2 14.552 2 14V5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'currency'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.6"/><path d="M9 5V13M6.5 7.5C6.5 6.672 7.172 6 8 6H10C10.828 6 11.5 6.672 11.5 7.5C11.5 8.328 10.828 9 10 9H8C7.172 9 6.5 9.672 6.5 10.5C6.5 11.328 7.172 12 8 12H10C10.828 12 11.5 11.328 11.5 10.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'users'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="7" cy="6" r="3" stroke="currentColor" stroke-width="1.6"/><path d="M1 15C1 12.239 3.686 10 7 10C10.314 10 13 12.239 13 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M12 8C13.657 8 15 9.343 15 11M12 3C13.657 3 15 4.343 15 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M17 15C17 13.5 16.036 12.247 14.5 11.638" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'ticket'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 7C2 6.448 2.448 6 3 6H15C15.552 6 16 6.448 16 7V9.5C15.172 9.5 14.5 10.172 14.5 11C14.5 11.828 15.172 12.5 16 12.5V14C16 14.552 15.552 15 15 15H3C2.448 15 2 14.552 2 14V11.5C2.828 11.5 3.5 10.828 3.5 10C3.5 9.172 2.828 8.5 2 8.5V7Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><line x1="7" y1="6" x2="7" y2="15" stroke="currentColor" stroke-width="1.4" stroke-dasharray="2 2"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'box'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M3 5L9 2L15 5V13L9 16L3 13V5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 2V16M3 5L9 8L15 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'tag'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.5 2H15C15.552 2 16 2.448 16 3V8.5C16 8.765 15.895 9.02 15.707 9.207L9.207 15.707C8.817 16.098 8.183 16.098 7.793 15.707L2.293 10.207C1.902 9.817 1.902 9.183 2.293 8.793L8.793 2.293C8.98 2.105 9.235 2 9.5 2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="5.5" r="1.2" fill="currentColor"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'warehouse'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 8L9 3L16 8V15H2V8Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><rect x="7" y="10" width="4" height="5" stroke="currentColor" stroke-width="1.6"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'droplet'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 2C9 2 4 8.163 4 11.4C4 14.028 6.239 16 9 16C11.761 16 14 14.028 14 11.4C14 8.163 9 2 9 2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'wrench'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M11.5 2C9.567 2 8 3.567 8 5.5C8 6.052 8.121 6.575 8.336 7.043L2 13.379L4.621 16L10.957 9.664C11.425 9.879 11.948 10 12.5 10C14.433 10 16 8.433 16 6.5C16 5.948 15.879 5.425 15.664 4.957L13.5 7.121L11.5 5.121L13.664 2.957C13.196 2.121 12.552 2 11.5 2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'cylinder'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="6" y="1.5" width="6" height="3" rx="1" stroke="currentColor" stroke-width="1.6"/><path d="M5.5 4.5H12.5C13.328 4.5 14 5.172 14 6V14.5C14 15.328 13.328 16 12.5 16H5.5C4.672 16 4 15.328 4 14.5V6C4 5.172 4.672 4.5 5.5 4.5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><line x1="4" y1="9.5" x2="14" y2="9.5" stroke="currentColor" stroke-width="1.4" stroke-dasharray="2 2"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'contact'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="2" y="3" width="14" height="12" rx="2" stroke="currentColor" stroke-width="1.6"/><circle cx="7" cy="8.5" r="1.8" stroke="currentColor" stroke-width="1.6"/><path d="M4 13C4 11.4 5.343 10.2 7 10.2C8.657 10.2 10 11.4 10 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><line x1="12" y1="7" x2="14" y2="7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><line x1="12" y1="10" x2="14" y2="10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'building'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="3" y="2" width="9" height="14" stroke="currentColor" stroke-width="1.6"/><rect x="12" y="7" width="3" height="9" stroke="currentColor" stroke-width="1.6"/><line x1="5.5" y1="5" x2="5.5" y2="5.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="9" y1="5" x2="9" y2="5.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="5.5" y1="8.5" x2="5.5" y2="8.51" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="9" y1="8.5" x2="9" y2="8.51" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'modules'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><rect x="2" y="2" width="6" height="6" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="10" y="2" width="6" height="6" rx="1.5" stroke="currentColor" stroke-width="1.6"/><rect x="2" y="10" width="6" height="6" rx="1.5" stroke="currentColor" stroke-width="1.6"/><path d="M12 9V15M9 12H15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'chart'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><line x1="2.5" y1="15" x2="15.5" y2="15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><rect x="4" y="9" width="2" height="5" fill="currentColor"/><rect x="8" y="5" width="2" height="9" fill="currentColor"/><rect x="12" y="7" width="2" height="7" fill="currentColor"/></svg>
      </ng-container>

      <ng-container *ngSwitchCase="'settings'">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="2.5" stroke="currentColor" stroke-width="1.6"/><path d="M9 1.5V3M9 15V16.5M3.697 3.697L4.757 4.757M13.243 13.243L14.303 14.303M1.5 9H3M15 9H16.5M3.697 14.303L4.757 13.243M13.243 4.757L14.303 3.697" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="1.6"/></svg>
      </ng-container>

    </ng-container>
  </span>

  @if (!collapsed()) {
    <span class="menu-item-label">{{ item().label }}</span>
  }
</ng-template>
